//* ===== FIX (2026-07-19) — חלק מתיקון "רענון אקראי" (401 → redirect) =====
//* נוספה תמיכה ב-options.skipCache: מאפשר ל-interceptor של axios לבקש טוקן טרי
//* מ-Clerk (עקיפת ה-cache הפנימי של Clerk) לפני ניסיון חוזר של בקשה שנכשלה ב-401.

export type ClerkTokenOptions = {
  /** true → Clerk ינפיק JWT חדש במקום להחזיר טוקן מה-cache (לשימוש אחרי 401). */
  skipCache?: boolean;
};

let tokenGetter: null | ((options?: ClerkTokenOptions) => Promise<string | null>) = null;

export function setClerkTokenGetter(fn: (options?: ClerkTokenOptions) => Promise<string | null>) {
  tokenGetter = fn;
}

export function clearClerkTokenGetter() {
  tokenGetter = null;
}

/** Brief wait so descendants' effects (SignalR, onboarding) don't race ClerkBootstrap's registration. */
async function waitForTokenGetter(maxMs = 15_000): Promise<boolean> {
  if (tokenGetter) return true;
  const deadline = Date.now() + maxMs;
  while (!tokenGetter && Date.now() < deadline) {
    await new Promise<void>((resolve) => {
      setTimeout(resolve, 32);
    });
  }
  return tokenGetter !== null;
}

export async function getClerkToken(options?: ClerkTokenOptions): Promise<string | null> {
  await waitForTokenGetter();
  if (!tokenGetter) return null;
  return await tokenGetter(options);
}
